import { HTMLAttributes } from 'react'

import { ResponsiveImage, ResponsiveImageProps } from '@syconium/little-miss-figgy'

import * as Styles from './styles'

export type EmbroideryLogoProps = Pick<ResponsiveImageProps, 'src' | 'alt' | 'widths'> &
  HTMLAttributes<HTMLDivElement>

export function PortalEmbroideryLogo({ src, alt, widths, ...rest }: EmbroideryLogoProps) {
  return (
    <Styles.LogoWrapper {...rest}>
      <ResponsiveImage
        src={src}
        alt={alt}
        widths={widths}
        // dimensions of logo embroidery image are not statically known
        aspectRatios={{ sm: null, md: null, lg: null }}
        loading='default'
      />
    </Styles.LogoWrapper>
  )
}
